import React, {
  useCallback,
  useState,
  useRef,
  useEffect,
  useContext,
} from "react";

import SignUp from "./SignUp";
import SignIn from "./SignIn";
import StartPage from "./StartPage";
import PageDashboard from "./PageDashboard";
import UserProfile from "./UserProfile";
// import Loader from "./Loader";
// import PostPage from "./PostPage";
import PageAddNewSite from "./PageAddNewSite";
import PageAddNewWall from "./PageAddNewWall";
import PageAddNewMeasurement from "./PageAddNewMeasurement";
import PageEditSite from "./PageEditSite";
import PageEditWall from "./PageEditWall";
import PageEditMeasurement from "./PageEditMeasurement";
import PageSiteSingle from "./PageSiteSingle";
import WallTab from "./Wall";
import PageWallSingle from "./PageWallSingle";
import PageMeasurementSingle from "./PageMeasurementSingle";

// import WallDetailsTets from "./WallDetailsTets";
import PrivateRoute from "./PrivateRoute";
import ForgotPassowrd from "./ForgotPassword";
import PrivateRouteUserProfile from "./PrivateRouteUserProfile";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Layout from "./Layout";

import { ColorModeContext } from "../context/ColorModeProvider";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { ThemeProvider } from "@mui/material/styles";
// import { createTheme } from "../theme";

import { createBrowserHistory } from "history";

const App = () => {
  const { mode } = useContext(ColorModeContext);
  const history = createBrowserHistory();
  return (
    // <ThemeProvider theme={theme}>

    <Router history={history}>
      <Layout>
        <Switch>
          <Route exact path="/" component={StartPage} />
          <Route path="/dashboard" component={PageDashboard} />
          <Route path="/addnewsite" component={PageAddNewSite} />
          <PrivateRoute path="/signup" component={SignUp} />
          <PrivateRoute path="/login" component={SignIn} />
          <PrivateRouteUserProfile
            path="/user-profile"
            component={UserProfile}
          />

          <Route path="/sites/:id" component={PageSiteSingle} />
          <Route path="/editsite/:id" component={PageEditSite} />

          {/* <Route path="/walls/:id">
            <PageWallSingle />
          </Route> */}
          <Route path="/walls/:id" component={PageWallSingle} />

          {/* <Route path="/editwall/:id">
            <PageEditWall />
          </Route> */}
          <Route path="/editwall/:id" component={PageEditWall} />

          <Route path="/addnewwall/:id" component={PageAddNewWall} />

          <Route
            path="/addnewmeasurement/:id"
            component={PageAddNewMeasurement}
          />

          <Route path="/measurements/:id" component={PageMeasurementSingle} />

          <Route path="/editmeasurement/:id" component={PageEditMeasurement} />

          <Route exact path="/forgot-password" component={ForgotPassowrd} />
        </Switch>
      </Layout>
    </Router>
    // </ThemeProvider>
  );
};

export default App;
